import classNames from 'classnames';

import styles from './SkeletonBox.module.scss';

export interface SkeletonBoxProps {
    width?: string | number;
    height?: string | number;
    className?: string;
    borderRadius?: string | number;
}

export default function SkeletonBox(props: SkeletonBoxProps) {
    const { width, height, className, borderRadius = '8px' } = props;

    const style = {
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        borderRadius: typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius,
    };

    return (
        <div className={classNames(styles.skeleton, className)} style={style} aria-hidden="true" />
    );
}
